import { jsx as _jsx } from "react/jsx-runtime";
import { ScrollableContainer } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import { useCallback } from 'react';
import { MediaService } from '../../../services/media/MediaService';
import { BottomCenter, Popup, TopCenter } from '../../../utils/popups';
import { DeviceSelector, DeviceSelectorContainer, DeviceSelectorPopupRoot, } from './DeviceSelectorPopup';
export const MicrophoneSelectorPopup = ({ reject, resolve, variant, ...props }) => {
    const mediaService = MediaService.getNotificationInterface();
    const audioDevices = MediaService.getOutput().useAudioDevices();
    const selectedDevice = MediaService.getOutput().useSelectedAudioDevice();
    const isMuted = MediaService.getOutput().useAudioMuted();
    const hasPermission = MediaService.getOutput().useMicrophonePermissioned();
    const onDeviceSelect = useCallback((device) => {
        mediaService.notifyAudioDeviceSelected(device);
        resolve();
    }, [mediaService, resolve]);
    const onAllowAccess = useCallback(() => {
        mediaService.notifyMediaPermissionsRequested({ audio: true });
        resolve();
    }, [mediaService, resolve]);
    const onEnableChange = useCallback((enabled) => {
        mediaService.notifyAudioMutingChangeRequested(!enabled);
    }, [mediaService]);
    const translateFn = variant === 'top-center' ? TopCenter : BottomCenter;
    return (_jsx(DeviceSelectorPopupRoot, { className: variant, reject: reject, translateFn: translateFn, ...props, children: _jsx(ScrollableContainer, { children: _jsx(DeviceSelectorContainer, { children: _jsx(DeviceSelector, { label: "Microphone", devicesList: audioDevices, selectedDevice: selectedDevice, onDeviceSelect: onDeviceSelect, isEnabled: !isMuted, onEnableChange: onEnableChange, onClose: reject, hasAccessToDevices: hasPermission, onAllowAccess: onAllowAccess }) }) }) }));
};
const microphonePopup = Popup.create(MicrophoneSelectorPopup);
export function selectMicrophone(options) {
    executeSoon(async () => {
        options.onOpenPopup?.();
        try {
            await microphonePopup.pop({
                anchorRef: options.anchorRef,
                variant: options.variant,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    });
}
